export enum InvoiceStatusType {
  Open = "Open",
  Closed = "Closed",
  Sent = "Sent",
  Paid = "Paid",
  Overdue = "Overdue",
}
